import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthGuard = ({ children }: any) => {
  const user = useSelector(({ UserSlice }: any) => UserSlice.user);

  if (!user.email) {
    return <Navigate to="/sign-in" />;
  }

  return <div>{children}</div>;
};

export default AuthGuard;
